import * as types from "../constants/NewsConstants";

const initialState = {
  isLoading: false,
  error: null,
  success: false,
  uploadedImageUrl: "",
  newsList: [],
};

const NewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_NEWS_REQUEST:
    case types.UPLOAD_IMAGE_REQUEST:
    case types.FETCH_NEWS_REQUEST:
    case types.DELETE_NEWS_REQUEST:
    case types.UPDATE_NEWS_REQUEST:
      return { ...state, isLoading: true, error: null, success: false };

    case types.CREATE_NEWS_SUCCESS:
    case types.UPDATE_NEWS_SUCCESS:
      return { ...state, isLoading: false, success: true };

    case types.FETCH_NEWS_SUCCESS:
      return { ...state, isLoading: false, newsList: action.payload };

    case types.DELETE_NEWS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        newsList: state.newsList.filter((n) => n.Slug !== action.payload),
      };

    case types.UPLOAD_IMAGE_SUCCESS:
      return { ...state, isLoading: false, uploadedImageUrl: action.payload };

    case types.CREATE_NEWS_FAIL:
    case types.UPLOAD_IMAGE_FAIL:
    case types.FETCH_NEWS_FAIL:
    case types.DELETE_NEWS_FAIL:
    case types.UPDATE_NEWS_FAIL:
      return { ...state, isLoading: false, error: action.payload };

    case types.CLEAR_IMAGE_URL:
      return { ...state, uploadedImageUrl: "" };

    case types.RESET_NEWS_STATE:
      return { ...initialState, newsList: state.newsList };

    default:
      return state;
  }
};

export default NewsReducer;
